import React from 'react';
import { RotateCcw } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import Paging from '@/shared/components/Common/Paging';
import SearchBar from '@/shared/components/Common/SearchBar';
import { useInitialPage } from '@/shared/hooks/useInitialPage';
import { useProductList } from './hooks/useProductList';

import ProductListTable from './components/UI/ProductListTable';

const ProductListPage: React.FC = () => {
  const navigate = useNavigate();
  useInitialPage();
  const {
    products,
    currentPage,
    totalPages,
    keyword,
    isLoading,
    hasError,
    isEmpty,
    shouldReset,
    totalCount,
    handlePageChange,
    handleSearch,
    handleReset,
    handleResetComplete,
    handleRefresh,
    error,
  } = useProductList();

  const moveToCreatePage = () => {
    navigate('/product/create');
  };

  return (
    <div className="min-h-screen bg-[#F1F1F1]">
      <div className="px-8 pt-6">
        <h2 className="text-2xl font-bold">Product</h2>

        {/* Button Container */}
        <div className="mb-5 flex justify-end gap-2">
          <button
            type="button"
            className="flex h-7 w-7 cursor-pointer items-center justify-center rounded bg-[#E2E2E2] transition-colors hover:bg-opacity-80"
            onClick={handleReset}
            disabled={isLoading}
          >
            <RotateCcw size={16} className="text-[#1D1D1D]" />
          </button>

          <button
            type="button"
            className="cursor-pointer rounded bg-[#1D1D1D] px-3 py-1 text-sm font-medium text-white transition-colors hover:bg-opacity-80"
            onClick={moveToCreatePage}
          >
            Add Product
          </button>
        </div>

        {/* Search Box */}
        <SearchBar
          onSearch={handleSearch}
          shouldReset={shouldReset}
          onResetComplete={handleResetComplete}
          initialValue={keyword}
        />

        <ProductListTable
          products={products}
          isLoading={isLoading}
          hasError={hasError}
          isEmpty={isEmpty}
          error={error}
        />

        {/* Pagination */}
        {!isLoading && !hasError && totalPages > 0 && (
          <div className="flex-none border border-x-[#DEDEDE] bg-[#E8E8E8] pb-4 pt-3">
            <Paging
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
              totalPage={totalPages}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductListPage;
